export interface SettlementFilters {
  from: string;
  to?: string;
  phone?: string;
  username?: string;
}

export interface PageInfomation {
  page: number;
  limit: number;
}

export interface SettlementListFilters extends SettlementFilters {
  page: number;
  limit: number;
}

export interface SettlementListResponse {
  pagination: Pagination;
  settlementDetails: Array<SettlementDetails>;
}

export interface Pagination {
  limit: number;
  offset: number;
  pageCount: number;
  totalCount: number;
}

export interface SettlementDetails {
  id: number;
  orderId: string;
  orderType: string;
  agencyType?: string;
  patientName: string;
  phone: string;
  payStatus: string;
  isRefunded: boolean;
  price: number;
  fee: number;
  doneAt: string;
  createdAt: string;
}

export interface SettlementSummary {
  count: number;
  fee: number;
  settlementPrice: number;
  totalPrice: number;
}
export interface SettlementCountByType {
  type: string;
  count: number;
}

export interface formattedCount {
  [key: string]: number;
}

export const ORDER_LIST_TABS = {
  PHARMACY: { tabKey: 'pharmacy', tabName: '결제내역' },
  VARIANCE: { tabKey: 'variance', tabName: '변동내역' }
} as const;

export type ORDER_LIST_TABS =
  typeof ORDER_LIST_TABS[keyof typeof ORDER_LIST_TABS]['tabKey'];

export type ARRAY_ORDER_LIST_TYPES = Array<
  typeof ORDER_LIST_TABS[keyof typeof ORDER_LIST_TABS]
>;
